import SeoMeta from "../../components/base/SeoMeta";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import ToursSection from "./components/ToursSection";
import VisaSection from "./components/VisaSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";

const BASE_URL = (import.meta.env.VITE_SITE_URL as string) || "https://flightfare.pk";

const HOME_JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "flightfare.pk",
    "url": BASE_URL,
    "description": "Pakistan's trusted travel booking platform for cheap flights, tours, Umrah packages, visa assistance and travel insurance.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${BASE_URL}/flights?from={from}&to={to}&date={date}`
      },
      "query-input": "required name=from required name=to required name=date"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "flightfare.pk",
    "alternateName": "Quick Fly Travel",
    "url": BASE_URL,
    "logo": "https://storage.readdy-site.link/project_files/6f8e2f56-80e7-4d90-9ea4-7823017b65ac/8001b0b9-8322-4e8e-a8ae-9e1b8da726a7_Untitled-design-13-2.png?v=4559551c5eed3b8ee3339af394cf2f6c",
    "image": "https://storage.readdy-site.link/project_files/6f8e2f56-80e7-4d90-9ea4-7823017b65ac/8001b0b9-8322-4e8e-a8ae-9e1b8da726a7_Untitled-design-13-2.png?v=4559551c5eed3b8ee3339af394cf2f6c",
    "description": "Pakistan's trusted travel agency for cheap flights, international tours, Umrah packages, visa assistance and travel insurance. Serving 25,000+ travelers since 2014.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "GF & BM 9A, AA Commercial, Street 1, Sector D",
      "addressLocality": "Bahria Town, Lahore",
      "addressRegion": "Punjab",
      "postalCode": "54000",
      "addressCountry": "PK"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 31.3585,
      "longitude": 74.1755
    },
    "telephone": "+923711432451",
    "email": "info@flightfare.pk",
    "foundingDate": "2014",
    "sameAs": [
      "https://www.facebook.com/share/1E1YkhMex1/",
      "http://instagram.com/flightfare.pk/"
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
        "opens": "09:00",
        "closes": "20:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Sunday",
        "opens": "11:00",
        "closes": "17:00"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Travel Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "International Flight Tickets" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Tour Packages" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Umrah Packages from Lahore" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Visa Assistance Pakistan" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Travel Insurance Pakistan" } }
      ]
    }
  }
];

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <SeoMeta
        title="flightfare.pk – Cheap Flights, Tours & Travel Bookings Pakistan"
        description="Book cheap flights, international tours, Umrah packages, visa assistance and travel insurance on flightfare.pk. Pakistan's trusted travel agency since 2014. Best fares guaranteed."
        keywords="cheap flights Pakistan, flight booking Pakistan, flightfare.pk, international tours Pakistan, Umrah packages Lahore, visa assistance Pakistan, travel agency Lahore"
        canonical="/"
        jsonLd={HOME_JSON_LD}
      />
      <Navbar />
      <HeroSection />
      <TrendingSection />
      <ToursSection />
      <VisaSection />
      <AboutSection />
      <Footer />
    </div>
  );
}
